/**
 * Fixed UI copy of „Obľúbené produkty“ (Figma 60325:20608, guest 60325:21367, mobile 60459:92480
 * and 60459:98469). Strings the core dictionary has letter for letter (Prihlásiť sa, Vytvoriť účet,
 * Najlacnejšie, Zrušiť …) are read with `t()` in the components.
 */
export const FAVORITES_COPY = {
  products: { one: 'produkt', few: 'produkty', other: 'produktov' },
  addAll: 'Pridať všetko do košíka',
  removeAll: 'Odstrániť všetky obľúbené',
  sort: {
    label: 'Zoradiť:',
    recent: 'Naposledy pridané',
  },
  priceAlert: {
    /** The adjective of „Na 2 obľúbené produkty“ follows the plural of „produkt“. */
    favorites: { one: 'obľúbený', few: 'obľúbené', other: 'obľúbených' },
    text: (products: string) =>
      `Na ${products} klesla cena. Upozornenia o zľavách vám pošleme aj e-mailom.`,
  },
  cart: {
    added: (products: string) => `Do košíka sme pridali ${products}.`,
    nothingAdded: 'Do košíka sme nepridali nič.',
    needsVariant: 'Vyberte variant na stránke produktu:',
    unavailable: 'Momentálne sa nedajú kúpiť:',
    failed: 'Nepodarilo sa pridať:',
  },
  removeDialog: {
    title: 'Odstrániť všetky obľúbené produkty?',
    description:
      'Zoznam sa vyprázdni na všetkých zariadeniach. Produkty si môžete znova uložiť srdiečkom.',
    failed: 'Niektoré produkty sa nepodarilo odstrániť. Skúste to znova.',
  },
  loadFailed: {
    title: 'Obľúbené produkty sa nepodarilo načítať',
    text: 'Skontrolujte pripojenie a skúste to znova.',
  },
  empty: {
    text: 'Srdiečkom pri produkte si ho uložíte sem. Zoznam uvidíte v počítači aj v mobile.',
    browse: 'Prezrieť kategórie',
  },
  guest: {
    /** Desktop breaks the title after „uložíte“ (Figma 60325:21978), phones wrap it naturally. */
    title: ['Obľúbené produkty si uložíte', 'po prihlásení'],
    text: 'Prihláste sa a srdiečkom si ukladajte produkty, ku ktorým sa chcete vrátiť. Zoznam uvidíte v počítači aj v mobile a dáme vám vedieť, keď zlacnejú.',
    back: 'Späť na domovskú stránku',
    benefits: [
      { icon: 'heart', text: 'Uložené na všetkých zariadeniach' },
      { icon: 'percent-duotone', text: 'Upozornenie na zľavu' },
      { icon: 'shopping-cart', text: 'Celý zoznam jedným klikom do košíka' },
    ],
  },
} as const;
